import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { TransferDto } from '../types';

export type CreateTransferRecordPayload = {
  receiptId: string;
  itemUuids: string[];
  categoryId: string;
};

export const useCreateTransferRecord = (transferId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<TransferDto, Error, CreateTransferRecordPayload>({
    mutationFn: (data) =>
      apiClient.post(`/v1/projects/${projectId}/transfers/${transferId}/records`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
      queryClient.invalidateQueries({ queryKey: ['transfer', transferId] });
      queryClient.invalidateQueries({ queryKey: ['transfer-receipt-suggestions', transferId] });
    },
  });
};
